module.exports = __webpack_public_path__ + "4e49ab5ec0e7438c8747ca6115fe30ea.MP3";